import {
    getDataWithParams
} from '@/store/config/method'
const initialState = () => ({
    list: {},
    request: {
        search: null,
        event_id: null,
        fromDate: null,
        toDate: null,
    },
    msg: 'Jaringan Bermasalah',
    status: 0
})
const state = initialState
const getters = {
    getList: state => state.list,
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status
}

const actions = {
    async getDashboardData({
        commit, state
    }, request) {
        try {
            var response = await getDataWithParams('/dashboard', request);
            state.request = request
            commit('SET_LIST', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.msg = error.data.msg
            state.status = error.data.status
        }else{
            state.msg = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_LIST(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.list = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}